function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1429 4.90909H16.4551C16.7564 4.90909 17 5.1533 17 5.45455C17 5.75579 16.7558 6 16.4545 6H9.54545C9.24421 6 9 5.75579 9 5.45455C9 5.1533 9.24369 4.90909 9.54493 4.90909H11.8571C12.5528 4.90909 12.7143 1.36364 12.4286 1.36364H11.0729C10.6963 1.36364 10.3913 1.05838 10.3913 0.681818C10.3913 0.30526 10.6966 0 11.0731 0H14.8896C15.2662 0 15.5714 0.30526 15.5714 0.681818C15.5714 1.05838 15.2665 1.36364 14.8899 1.36364H13.5714C13.2857 1.36364 13.6791 4.90909 14.1429 4.90909Z",
  fill: "#b09aee"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.14286 4.90909H7.45514C7.75639 4.90909 8 5.1533 8 5.45455C8 5.75579 7.75579 6 7.45455 6H0.545455C0.244208 6 0 5.75579 0 5.45455C0 5.1533 0.243688 4.90909 0.544934 4.90909H2.85714C3.5528 4.90909 3.71429 1.36364 3.42857 1.36364H2.07285C1.6963 1.36364 1.3913 1.05838 1.3913 0.681818C1.3913 0.30526 1.69656 0 2.07312 0H5.88961C6.26617 0 6.57143 0.30526 6.57143 0.681818C6.57143 1.05838 6.26645 1.36364 5.88989 1.36364H4.57143C4.28571 1.36364 4.67909 4.90909 5.14286 4.90909Z",
  fill: "#b09aee"
});

var SvgDetailRailIcon = function SvgDetailRailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 10,
    viewBox: "0 0 17 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetailRailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DetailRailIcon.c146e42e.svg";
export { ForwardRef as ReactComponent };